<div class="trust-name-search">
    <form @submit.prevent="submit_trust_name">
        <div class="form-group">
            <label for="trust_name" class="fw-bold text-xs">Trust Name</label>
            <input type="text" v-model="form.trust_name" class="form-control text-xs rounded-small p-3 shadow-sm" id="trust_name" required>
        </div>
        <div class="d-flex justify-content-end my-2">
            <button type="submit" class="btn btn-primary-color rounded-pill text-xs">
                Search
            </button>
        </div>
    </form>
</div>